(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gg-scrubber-bundle"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('gg-scrubber-bundle'))customElements.define('gg-scrubber-bundle',class extends HTMLElement{
  connectedCallback(){
    this.form=this.closest('form');
    this.update=()=>{
      const selected=this.querySelector('input:checked');
      const quantity=this.form?.querySelector('[name="quantity"]');
      if(!selected||!quantity)return;
      const component=this.form.querySelector('quantity-selector-component');
      if(component?.setValue)component.setValue(Number(selected.value));
      quantity.value=selected.value;
      quantity.dispatchEvent(new Event('change',{bubbles:true}));
      const pair=selected.value==='2';
      const scope=this.closest('.product-information');
      const price=scope?.querySelector('[data-gg-price]');
      if(price){if(!this.originalPrice)this.originalPrice=price.innerHTML;if(pair){price.replaceChildren();const current=document.createElement('span');current.className='gg-scrubber-current';current.textContent=this.dataset.pair;const old=document.createElement('s');old.className='gg-scrubber-original';old.textContent=this.dataset.original;const saving=document.createElement('span');saving.className='gg-scrubber-discount';saving.textContent=this.dataset.saving;price.append(current,old,saving)}else price.innerHTML=this.originalPrice}
      document.querySelectorAll('[data-gg-bundle-total]').forEach(el=>el.textContent=pair?this.dataset.pair:this.dataset.single);
      this.setAttribute('data-ready','');
    };
    this.addEventListener('change',this.update);
    this.frame=requestAnimationFrame(this.update);
  }
  disconnectedCallback(){cancelAnimationFrame(this.frame);this.removeEventListener('change',this.update)}
});
  } catch(e) { console.error(e); }
})();

})();
